var exports = {
  "iE": "VoiceChannelUserCount.module__wrapper___WjltdW",
  "VV": "VoiceChannelUserCount.module__users___WjltdW",
  "X5": "VoiceChannelUserCount.module__total___WjltdW",
};

module.exports = exports;
